import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  card: {
    padding: theme.spacing(3, 2),
    // @ts-ignore
    backgroundColor: theme.palette.warning.light,
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: 8,
    boxShadow: '0 10px 26px rgba(167, 104, 6, 0.1)',
    display: 'grid',
    gridGap: theme.spacing(4),
  },
  button: {
    justifySelf: 'center',
  },
}));
